import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Link, Route, Routes, useLocation, useSearchParams } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import { useLocalizedStrings } from "../../localization/LocalizedStringsProvider";
import { fillHeight } from "../../theme";
import BrandList from "./BrandList";
import LocationList from './LocationList';
import OrganizationList from './OrganizationList';

const Admin = () => {
    const app = useAppContext();
    const strings = useLocalizedStrings();
    const { pathname } = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    // Keep the selected org in the URL so it survives navigating to/from BrandDetails
    const selectedOrgId = searchParams.get("orgId") ?? undefined;

    const handleSelectOrganization = (id: string | undefined) => {
        setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            if (id) next.set("orgId", id);
            else next.delete("orgId");
            return next;
        }, { replace: true });
    }

    const orgBase = `/${app.organizationSlug}/admin/configuration/organizations`;
    const locationsBase = `/${app.organizationSlug}/admin/configuration/locations`;

    const tabValue =
        pathname.startsWith(locationsBase)
            ? locationsBase
            : pathname.startsWith(orgBase)
                ? orgBase
                : false;

    const OrgBrand = () => {
        return (
            <Stack direction="row" spacing={2} sx={{ flex: 1, minHeight: 0, p: 2 }}>
                <Box sx={{ flex: 2, minWidth: 0, display: "flex", flexDirection: "column" }}>
                    <OrganizationList onSelect={handleSelectOrganization} selectedId={selectedOrgId} />
                </Box>
                <Box sx={{ flex: 3, minWidth: 0, display: "flex", flexDirection: "column" }}>
                    <BrandList organizationId={selectedOrgId} />
                </Box>
            </Stack>
        );
    }

    return (
        <Box sx={{ ...fillHeight, overflow: "hidden" }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue}>
                    <Tab value={orgBase} label={strings.organizations} component={Link} to={orgBase} />
                    {/* Viewing the TouchTab org itself: only Organizations is relevant, not Locations. */}
                    {!app.isViewingSuperAdminOrg() &&
                        <Tab value={locationsBase} label={strings.locations} component={Link} to={locationsBase} />}
                </Tabs>
            </Box>
            <Box component="main" sx={{ ...fillHeight, overflow: 'hidden', flexGrow: 1, padding: 0 }}>
                <Routes>
                    <Route path="organizations" element={<OrgBrand />} />
                    <Route path="locations" element={<LocationList />} />                    
                </Routes>
            </Box>
        </Box>
    );
};

export default Admin;

//<Box sx={{ ...fillHeight, p: 2, overflow: "hidden" }}>
//            <Stack direction="row" spacing={2} sx={{ flex: 1, minHeight: 0 }}>
//                {app.isSuperAdmin() &&
//                    <Box sx={{ flex: 2,  minWidth: 0, display: "flex", flexDirection: "column" }}>
//                        <OrganizationList onSelect={handleSelectOrganization} />
//                    </Box>
//                }
//                <Box sx={{ flex: 2, minWidth: 0, display: "flex", flexDirection: "column" }}>
//                    <BrandList organizationId={selectedOrgId} onSelect={(id, brandType) => {
//                        setSelectedBrandId(id);
//                        setSelectedBrandType(brandType);
//                    }}/>
//                </Box>
//                <Box sx={{ flex: 3, minWidth: 0, display: "flex", flexDirection: "column" }}>
//                    <LocationList brandId={selectedBrandId} locationType={selectedBrandType} /> {/* Currently brandType and locationType are 1 - 1 mapping */}
//                </Box>
//            </Stack>
//        </Box>